module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wake up, Panta!” Pochita is saying. “It’s eight o’clock already. Panta, Pantita.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eight already? God, I’m tired,” yawns Pantita. “Did you sew on my new stripe?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Lieutenant, sir,” Pochita stands at attention. “Oh, excuse me, Captain, sir. Until I get used to it, honey, you’re going to continue being my little lieutenant. Yes, it looks just fine. But get up now—don’t you have an appointment?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, at nine,” Pantita is lathering his face. “Where will they send us, Pocha? Hand me the towel, please. Hey, where do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here, in Lima,” Pochita is looking out at the gray sky, the terraces, the cars, the pedestrians. “Oh, it just makes my mouth water: Lima, Lima, Lima.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be a dreamer. It’ll never be Lima. What a pipe dream,” Panta looks at himself in the mirror, knots his tie. “If it’s only some city like Trujillo or Tacna I’ll be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How funny this item in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("El Comercio")]), _vm._v(" is,” Pochita is making a face. “In Leticia some guy crucified himself to announce the end of the world. They put him in a nuthouse but people took him out by force because they think he’s a saint. Leticia’s in the Colombian part of the jungle, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How handsome you are dressed up as a captain, my son,” Mother Leonor puts the marmalade, bread and milk on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now it’s Colombia; before it was Peru. They took it away from us,” Panta spreads butter on a piece of toast. “Give me a little more coffee, Mama.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wish they’d send us to Chiclayo again,” Mother Leonor brushes the crumbs onto a plate and removes the tablecloth. “After all, we were so well off there, isn’t that so? To me, the main thing is that they don’t make us move too far from the coast. Get going, boy. Good luck. You have my blessing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the name of the Father and the Holy Ghost and the Son W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HO DIED ON THE CROSS")]), _vm._v(",” Brother Francisco raises his eyes to the night, lowers his eyes to the torches. “My hands are tied, the wood is an offering, make the sign of the cross for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Colonel López López is waiting for me, miss,” says Captain Pantaleón Pantoja.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And also two generals,” she gives him a funny look. “Just go in, Captain. Yes, that one, the brown door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s our man,” Colonel López López stands up. “Come in, Pantoja. Congratulations on that new stripe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The highest grade on your promotion exam and by unanimous decision of the judges,” General Victoria stretches out a hand, claps him on the shoulder. “Bravo, Captain. That’s how you serve career and country.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sit down, Pantoja,” General Collazos is motioning to a sofa. “Make yourself comfortable and hold on tight, so you can hear what you’re about to hear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t scare him, Tiger,” General Victoria is waving his hands. “He’s going to think we’re sending him to the slaughterhouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The heads of the quartermaster unit have come in person to notify you of your new assignment. That should tell you it’s got its problems,” Colonel López López adopts a grave expression. “Yes, Pantoja, it’s a rather delicate matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The presence of these chiefs is an honor for me,” Captain Pantoja clicks his heels. “Hell, Colonel, you’re really intriguing me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Want a cigarette?” Tiger Collazos takes out a cigarette, a lighter. “But don’t just stand there—sit down. What, you don’t smoke?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You see—for once the Intelligence Service was right,” Colonel López López pats a photocopy. “Just like it says: not a smoker, not a drinker, no wandering eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“An officer without vices,” General Victoria marvels. “Now we have someone to represent the military in Paradise, next to Santa Rosa and San Martin de Porres.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t exaggerate,” Captain Pantoja blushes. “I’ve got to have some vices you don’t know about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We know you better than you know yourself,” Tiger Collazos lifts a folder and puts it down on the table again. “Your eyes would pop if you knew the hours we’ve spent studying your life. We know what you did, what you didn’t do, and even what you will do, Captain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can recite your service record from memory,” General Victoria opens the folder, shuffles note cards and forms. “Not even one punishment as an officer and barely half a dozen demerits as a cadet. That’s why you’ve been selected, Pantoja.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“From among almost eighty officers in the division—no fewer,” Colonel López López raises an eyebrow. “Now you can puff up like a peacock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m grateful to you for the high opinion you have of me,” Captain Pantoja’s vision blurs. “I will do everything I can to live up to that confidence, Colonel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Captain Pantaleón Pantoja?” General Scavino is shaking the telephone. “I can hardly hear you. You’re sending him to me for what, Tiger?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You made a fine record for yourself in Chiclayo,” General Victoria is leafing through a report. “Colonel Montes was desperate to hold on to you. It seems the district ran like a watch, thanks to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘Born organizer, mathematical sense of order, executive capacity,’” Tiger Collazos reads. “‘He conducted the administration of the regiment with efficiency and real inspiration.’ My God, that half-breed Montes fell in love with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So much praise mixes me up,” Captain Pantoja lowers his head. “I’ve always tried to do my duty, nothing more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What service?” General Scavino lets out a horse laugh. “Look, Tiger, neither you nor Victoria can pull my leg. I’m no fool.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“O.K., let’s take the bull by the horns,” General Victoria seals his lips with a finger. “This business demands the utmost secrecy. I’m talking about the mission that’s going to be entrusted to you, Captain. All right, let the cat out of the bag, Tiger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In brief, the troops in the jungle are screwing the local women,” Tiger Collazos takes a breath, blinks and coughs. “There are rapes all over the place and the courts can’t handle them all. The entire Amazon District is up in arms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They bombard us daily with dispatches and accusations,” General Victoria is plucking at his beard. “And protest committees arrive from even the most out-of-the-way little towns.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your soldiers are dishonoring our women,” Mayor Paiva Runhuí squeezes his hat and loses his voice. “Just a few months ago they molested my dear sister-in-law and last week they almost raped my own wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, not my soldiers—the country’s soldiers,” General Victoria is making pacifying gestures. “Calm down, calm down, Mr. Mayor. The Army sincerely regrets your sister-in-law’s misfortune and will do what it can to compensate her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And do they call rape a ‘misfortune’ nowadays?” Father Beltrán gets rattled. “Because that’s what it was: rape.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two uniformed men grabbed Florcita as she was coming from the farm and they mounted her right there in the middle of the road,” Mayor Teófilo Morey bites his nails and hops up and down in place. “With such good aim that now she’s pregnant, General.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miss Dorotea, you’re going to identify those criminals for me,” growls Colonel Peter Casahuanqui. “No crying, no crying; you’ll see how I’m going to fix this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think I’m going to go outside?” sobs Dorotea. “Me, all alone, in front of all those soldiers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re going to march right by here, in front of the guardhouse,” Colonel Máximo Dávila is hiding behind the iron railing. “You’re going to peek out at them through the window and as soon as you spot the brutes, you’re going to point them out to me, Miss Jesús.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brutes?” Father Beltrán spits. “Wretches, curs, imbeciles, I’d say. To subject Mrs. Asunta to such infamy! To tarnish the uniform that way!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My servant, Luisa Cánepa, was violated by a sergeant, and then by a corporal and later by a private,” Lieutenant Bacacorzo is cleaning his glasses. “She must have liked it or something, Commander, but one thing we can be sure of now is that she’s turned into a prostitute by the name of Knockers and has some queer they call Chameleon for a pimp.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now point out to me, Miss Dolores, which of these men you want to marry,” Colonel Augusto Valdés is pacing in front of the three recruits. “And the chaplain will marry you this instant. Choose, choose. Which of these do you prefer as the father of your future baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They surprised my wife right in the church,” the carpenter Adriano Lharque is sitting stiffly on the edge of his chair. “Not the cathedral, but the Church of Santo Cristo de Bagazán, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s how it is, dear listeners,” bellows Sinchi. “Neither fear of God nor respect for His sacred house nor the noble gray hairs of that dignified matron, who has already given two generations to Loreto, were able to restrain those sacrilegious, those lustful men.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They began to tug at me, oh, my God, they wanted to throw me on the ground,” cries Mrs. Cristina. “They were falling-down drunk and you should have heard the obscenities they were saying. In front of the main altar, I swear to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The most charitable soul in all Loreto, General,” thunders Father Beltrán. “They violated her five times!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And also her little daughter and her little niece and her little adopted daughter—I know it all already, Scavino,” Tiger Collazos is blowing the dandruff off his epaulets. “But that priest Beltrán, is he for us or against us? Is he or isn’t he the Army chaplain?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I protest, both as a priest and as a soldier, General,” Father Beltrán sucks in his stomach, sticks out his chest. “Because these abuses do as much damage to the Army as to the victims.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course, what the recruits tried to do to the lady is very wrong,” General Victoria hedges, smiles, salutes. “But her relatives almost beat them to death; don’t forget that. I have the medical report here: broken ribs, contusions, shredded ears. In this case it was a tie, my dear doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To Iquitos?” Pochita stops sprinkling the shirt and holds up the iron. “Oh, how far away they’re sending us, Panta.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“With wood you make the fire that cooks your food, with wood you build the house where you live, the bed where you sleep and the raft on which you cross the river,” Brother Francisco is suspended above the forest of unmoving heads, anxious faces and open arms. “With wood you make the harpoon that catches the fish, the spear that hunts the warthog and the coffin in which you bury the dead. Sisters! Brothers! Kneel down for me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s one hell of a problem, Pantoja,” Colonel López López is shaking his head. “In Contamana the mayor issued an order telling the residents to lock their women up at home when the troops are on leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And especially so far away from the water,” Mother Leonor drops the needle, ties off the thread and cuts it with her teeth. “Are there many mosquitoes up there in the jungle? You know how they bother me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take a look at this list,” Tiger Collazos is scratching his forehead. “Forty-three pregnancies in less than a year. The chaplains under Father Beltrán married about twenty women, but of course, this depravity requires more radical measures than forced marriages. Up till now punishments and warnings have not changed the picture: a soldier arrives in the jungle and turns into a prick gone crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you’re the one who seems least excited about the place, dear,” Pochita goes around opening and dusting off suitcases. “Why, Panta?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It has to be the heat, the climate, don’t you think?” Tiger Collazos gets excited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very likely, General,” stammers Captain Pantoja.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The warm humidity, that excess of nature,” Tiger Collazos passes his tongue over his lips. “It always happens to me: I get to the jungle and I start breathing fire—I feel like my blood is boiling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If your wife hears you”—General Victoria laughs—“watch out for her claws, Tiger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At first we thought it was the diet,” General Collazos slaps his belly. “That the garrisons used a lot of spices, something that made the men’s sexual appetites worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We consulted specialists, even a Swiss doctor who cost a pile of money,” Colonel López López is rubbing two fingers together. “A dietitian loaded with titles.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pas d’inconvénient")]), _vm._v(",” notes Professor Bernard Lahoe in a little book. “We will prepare a diet that, without diminishing the necessary proteins, will weaken the libido of the soldiers by eighty-five percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t go overboard,” mumbles Tiger Collazos. “We don’t want a troop of eunuchs either, Doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Horcones to Iquitos, Horcones to Iquitos,” Second Lieutenant Santana is getting impatient. “Yes, very important, top priority. We have not obtained the expected results with Operation Swiss Ration. My men are dying of hunger, of tuberculosis. Today another two fainted during inspection, Commander.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No joking, Scavino,” Tiger Collazos is wedging the telephone between his ear and his shoulder while he lights a cigarette. “We’ve gone over and over it and this is the only solution. I’m sending Pantoja to you, with his mother and his wife. Have a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pochita and I already got used to the idea and we’re glad about going to Iquitos,” Mother Leonor is folding handkerchiefs, sorting skirts, packing shoes. “But you’re still down in the mouth. What’s the matter with you, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the man, Pantoja,” Colonel López López stands up and grabs him by the arms. “You’re going to put an end to this headache.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“After all, it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a city, Panta, and it seems nice,” Pochita is throwing rags into the garbage, tying knots, closing her pocketbooks. “Don’t make such a face. Wouldn’t the mountains be worse?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To tell you the truth, Colonel, I can’t see how,” Captain Pantoja swallows. “But sure, I’ll do what I’m ordered.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For the time being, you’ll go to the jungle,” Colonel López López grabs a pointer and marks a spot on the map. “Your center of operations will be Iquitos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re going to get to the root of this problem and nip it in the bud,” General Victoria strikes his open hand with his fist. “Because, as you must’ve guessed, Pantoja, the problem isn’t just women being molested.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But also recruits condemned to living like monks in all that wicked heat,” clucks Tiger Collazos. “Serving in the jungle is very tough, Pantoja, very brave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Every skirt is spoken for in the Amazon settlements,” Colonel López López is gesturing. “There’s no red-light district, no loose women or anything like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The men spend all week locked up, carrying out details in the mountains, dreaming about their day off,” General Victoria imagines. “They walk miles to the nearest town. And what happens when they get there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing. Because of the damned lack of females,” Tiger Collazos shrugs. “And then the ones who don’t get laid lose control after the first glass of anisette and jump like panthers on whatever walks by.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’ve reported cases of buggery and even bestiality,” Colonel López López states precisely. “Would you believe that a corporal in Horcones was taken by surprise while carrying on like a newlywed with a monkey?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The monkey answers to the absurd name of Milkmaid of the Fifth Barracks,” Second Lieutenant Santana is choking on his laughter. “Or rather "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("answered")]), _vm._v(", because I killed her with a single shot. The degenerate is in the guardhouse, Colonel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In short, abstinence makes for a hell of a lot of corruption,” says General Victoria. “And demoralization, nervousness, apathy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve got to give these starving men something to eat, Pantoja,” Tiger Collazos is looking him solemnly in the eyes. “Here’s where you come into the picture, here’s where we’re going to use your organizing brain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Panta, why are you sitting there so quiet and mixed up?” Pochita puts the ticket in her wallet and asks where the gate to the plane is. “There’ll be a big river. We can go swimming, take walks to see the Indians. Cheer up, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Son, what’s making you act so strange?” Mother Leonor is watching the clouds, the propellers, the trees. “You haven’t opened your mouth the whole trip. What’s bothering you so much?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing, Mama. Nothing, Pochita,” Panta is fastening his seat belt. “I’m all right, nothing’s the matter. Look, we’re landing. Isn’t that the Amazon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All this time you’ve been acting like a dumbbell,” Pochita is putting on her sunglasses, taking off her coat. “You haven’t said a word, you sleep with your eyes open. God, how hot it is. I’ve never seen you so changed, Panta.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was a little worried about my new assignment, but that’s all over with now,” Panta takes out his wallet and hands a few bills to the driver. “Yes, that’s right—number 549, Hotel Lima. Wait, Mama—I’ll help you get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re an officer, aren’t you?” Pochita throws her travel bag on a chair, takes off her shoes. “You knew they could send you anywhere. Iquitos isn’t bad, Panta—can’t you see it looks like a nice place?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re right. I’ve been acting like a dumbbell,” Panta opens the closet, hangs up a uniform and a suit. “Maybe I’d grown fond of Chiclayo. I promise that’s all over. All right, let’s unpack. Can you believe this heat, babe?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As for me, I could live here in the hotel for the rest of my life,” Pochita is lying on her back on the bed, stretching out. “They do everything for you. You don’t have to worry about anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And would it be right to have Cadet Pantoja in a cheap hotel?” Panta is taking off his tie, his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cadet Pantoja?” Pochita opens her eyes, unbuttons her blouse, leans an elbow on the pillow. “Really? Can we take care of that now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Didn’t I promise you we would once I got my third stripe?” Panta shakes his trousers, folds and hangs them up. “He’ll come from Loreto—how does that strike you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great, Panta,” Pochita is laughing, clapping, bouncing up and down on the mattress. “Whee, I’m happy—the little cadet, Pantita Junior.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We have to take care of this right away,” Panta opens his hands, comes closer. “So he gets here soon. Come over here, babe—where are you running to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, what’s wrong with you?” Pochita jumps from the bed, runs toward the bathroom. “Have you gone crazy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“C’mon, c’mon, for Pantita’s sake,” Panta stumbles over a suitcase, knocks over a chair. “Let’s take care of it right now. C’mon, Pochita.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it’s eleven in the morning. We just got here,” Pochita spars, pulls back, shoves, gets mad. “Let go; your mother’s going to hear us, Panta.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To break in Iquitos, to break in the hotel.” Pantita pants, fights, embraces, slips. “Come here, beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now you see what’s been gained by so many threats and dispatches,” General Scavino is brandishing a written communiqué covered with stamps and signatures. “You’re also to blame for this, Commander Beltrán. Look at what this guy’s beginning to organize in Iquitos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going to tear my skirt,” Pochita hides behind the wardrobe, throws a pillow, begs for a truce. “Panta, I don’t recognize you. You’re always so…so formal; what’s happening to you? Let go—I’ll take it off myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wanted to cure a disease, not cause one,” Commander Beltrán reads and rereads General Scavino’s flushed face. “I never imagined the medicine would be worse than the sickness, General. Unthinkable, terrible. Are you going to permit this atrocity?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The bra, the stockings,” Pantita perspires, throws himself down, leans back, stretches out. “Tiger was right: in this humidity, you breathe fire, your blood boils. C’mon, nibble me where I like it. The ear, Pocha.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m embarrassed in the daytime, Panta,” Pochita complains, wraps herself in the bedspread, sighs. “You’re going to fall asleep. Don’t you have to be at headquarters at three? You always do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll take a shower,” Pantita kneels, bends over, straightens up. “Don’t talk to me, don’t distract me. Nibble my ear. Like that, just like that. Ahh, I already feel like I’m coming. Oh, babe, I can’t tell who I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know very well who you are and why you’ve come to Iquitos,” mutters General Roger Scavino. “And straight off I’ll tell you that your presence in this city doesn’t please me one bit. Let’s get things clear from the start, Captain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Excuse me, General,” Captain Pantoja stammers. “There must be some misunderstanding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not in favor of this Special Service you’ve come to organize,” General Scavino moves his bald head nearer the fan and closes his eyes for a moment. “I was opposed from the beginning and I still think it’s an outrage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And above all, an unspeakable act of immorality,” Father Beltrán is fanning himself furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The commander and I have kept silent because our superiors are the ones who give the orders,” General Scavino unfolds his handkerchief and wipes the sweat from his forehead, temples, neck. “But they haven’t convinced us, Captain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t have anything to do with this project, General,” Pantoja, motionless, perspires. “It was the surprise of my life when they told me about it, Father.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Commander,” Father Beltrán corrects him. “Can’t you count stripes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Excuse me, Commander,” Pantoja lightly clicks his heels. “I didn’t have anything to do with it, I promise you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aren’t you one of the brains in the quartermaster unit who thought up this nonsense?” General Scavino grabs the fan, puts it in front of his face, his skull, and clears his throat. “Anyway, there are some things that have to be understood from the start. There’s no way I can stop this from happening, but I’ll see to it that this touches the armed forces as little as possible. No one is going to spoil the image the Army has won for itself in Loreto since I’ve been in charge of the Fifth Region.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what I want too,” Pantoja is looking over the general’s shoulder at the muddy water of the river, at a barge filled with bananas, at the blue sky, at the fiery sun. “I’m ready to do what I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because if the news leaked, there’d be an ugly mess,” General Scavino raises his voice, stands up, rests his hands on the window sill. “The strategists in Lima calmly plan dirty tricks at their desks, because it’s General Scavino who’ll have to weather the storm if the thing becomes public.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I agree with you, you have to believe me,” Captain Pantoja sweats, sees the sleeves of his uniform getting wet, implores. “I never would’ve asked for this assignment. It’s something so different from my usual work, I don’t even know if I’ll be able to carry it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your father and your mother came together on wood to make you, and the woman who carried you struggled and opened her legs to give birth to you on wood,” Brother Francisco is screeching and thundering up there in the darkness. “The wood felt H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IS")]), _vm._v(" body, grew red with H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IS")]), _vm._v(" blood, received H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IS")]), _vm._v(" tears, grew moist with H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IS")]), _vm._v(" sweat. The wood is sacred, the plank brings health. Sisters! Brothers! Open your arms to me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dozens of people will march through that door. This office will be filled with protests, with signed documents, with anonymous letters,” Father Beltrán gets agitated, takes a few steps, comes back, opens and shuts his fan. “All the Amazon District will raise the roof and think the mastermind of the scandal is General Scavino.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can already hear that demagogue Sinchi vomiting out his slander against me on the radio,” General Scavino turns, is suddenly disturbed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My instructions are for the Special Service to function with the greatest secrecy,” Captain Pantoja dares to take off his kepi, to rub a handkerchief across his forehead, to wipe his eyes. “I’ll keep those orders very much in mind at every moment, General.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what the hell could I invent to placate the people?” General Scavino shouts, goes around the desk. “Have they given any thought in Lima to the role I’ll have to play?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you’d rather, I can ask for my transfer today,” Captain Pantoja grows pale. “To prove to you that I have no interest in the Special Service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What a euphemism these geniuses have thought up,” Father Beltrán taps his heels, his back turned, looking at the glistening river, the cabañas, the level stretch of trees. “Special Service…Special Service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing doing with transfers; they’d send me another officer in a week,” General Scavino sits down again, fans himself, wiping his bald pate. “It’s up to you whether this hurts the Army or not. You’ve got a responsibility on your shoulders as big as a volcano.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can sleep peacefully, General,” Captain Pantoja stiffens, throws back his shoulders, looks straight ahead. “The Army is what I respect and love most in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The best way you can serve it now is to keep far away from it,” General Scavino softens his tone and attempts a friendly expression. “While you’re in command of that Service, at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry,” blinks Captain Pantoja. “What are you saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want you ever to set foot in the quartermaster’s or in the barracks at Iquitos,” General Scavino turns the palms and backs of his hands to the humming, invisible blades of the fan. “You’re excused from attending all official functions, parades, Te Deums. Also from wearing a uniform. You’ll dress only in civilian clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I even have to come to work in mufti?” Captain Pantoja continues to blink.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your work is going to be very far away from the quartermaster’s,” observes General Scavino with misgiving, with consternation, with piety. “Don’t be naïve, man. Do you think that I’d be able to open an office for you here—for the traffic you’re going to organize? I’ve arranged for a depot on the outskirts of Iquitos, by the river. Always dress as a civilian. No one must find out that that place has any connection with the Army. Understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, General,” the astonished Captain Pantoja is nodding. “Only…well, I wasn’t expecting anything like this. It’s going to be—I don’t know—like changing my personality.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Remember that you’ve been assigned to the Intelligence Service”—Commander Beltrán comes away from the window, approaches him, gives him a benevolent smile—”and that your life depends on your ability to go unnoticed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll try to adapt, General,” stammers Captain Pantoja.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nor is it advisable for you to live on the army base, so go look for a small house in the city,” General Scavino is mopping a handkerchief over his eyebrows, ears, lips and nose. “And I want you to have no relations with the officers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean friendly relations, General?” Captain Pantoja chokes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re not going to be amorous,” Father Beltrán laughs or grunts or chokes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know it’s difficult, that it’s going to be hard on you,” General Scavino agrees in a friendly way. “But there’s no other way, Pantoja. Your mission will place you in contact with all kinds of people in the Amazon District. The only way to avoid any reflection on the Army is by sacrificing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In short, I must conceal my position as an officer,” Captain Pantoja sees in the distance a naked boy climbing a tree, a lame pink heron, a horizon of burning underbrush. “Dress as a civilian, mix with civilians, work as a civilian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But always think as an officer,” General Scavino is banging on the table. “I’ve appointed a lieutenant who will serve as a liaison between us. You’ll see each other once a week and through him you’ll give me an account of your activities.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry at all. I’ll be quiet as a tomb,” Lieutenant Bacacorzo raises the glass of beer and toasts the other’s health. “I’m on top of it all, Captain. Is it all right if we meet on Tuesdays? I thought the meeting place should always be bars and brothels. You’ll have to hang out a lot in those places now, won’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He made me feel like a delinquent, some kind of leper,” Captain Pantoja is examining the stuffed monkeys, parrots and birds, the men who drink standing at the bar. “How the hell am I going to start working if even General Scavino is sabotaging me? If my own superior starts out by discouraging me, by asking me to disguise myself, by not letting me be seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You went to headquarters so happy and you come home again with that dumb face on,” Pochita stands on tiptoe and kisses him on the cheek. “What happened, Panta? Did you get there late and get hollered at by General Scavino?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll help you as much as I can, Captain,” Lieutenant Bacacorzo offers him potato chips. “I’m not an expert, but I’ll do what I can. Don’t complain; a lot of officers would give anything to be in your shoes. Think what freedom you’re going to have. You’ll choose your own hours, your own schedule. Besides all the other tidbits—eh, Captain?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We are going to live "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here")]), _vm._v(", in this ugly place?” Mother Leonor is looking at the peeling walls, the dirty floors, the cobwebs on the ceiling. “Why didn’t they give you one of those pretty houses on the army base? Once again, Panta, you’re not enough of a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t think I’m becoming a defeatist, Bacacorzo; it’s just that I’m really at a loss,” Captain Pantoja tastes, chews, swallows, mumbles delicious. “I’m a good administrator, sure. But they’ve taken me out of my depth and now I don’t know my ass from a hole in the ground.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you take a look at your center of operations yet?” Lieutenant Bacacorzo is filling the glasses again. “General Scavino has sent around an order: no officer in Iquitos can go near that warehouse on the Itaya River, under penalty of thirty days hard labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not yet. I’ll go tomorrow, early,” Captain Pantoja drinks, wipes his mouth, holds back a burp. “Because let’s be frank: to do this the way they’re asking, you’d need some experience in the business. Know the night world, have been a little wild.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you going to the quartermaster’s like that, Panta?” Pochita comes near him, touches the sleeveless shirt, sniffs at the blue pants, the little jockey cap. “What about your uniform?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unfortunately, that’s not my case,” Captain Pantoja grows sad, sketches an embarrassed gesture. “I never was wild. Not even when I was a kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can’t get together with the officers’ families?” Mother Leonor flourishes the feather duster, the broom, a bucket, dusts, cleans, scrubs, becomes frightened. “We have to live as if we’re civilians?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just think—when I was a cadet, I chose to stay in school studying on the days when we had leave,” Captain Pantoja is remembering nostalgically. “Grinding away at math, most of all, is what I like best. I never went out to parties. Though maybe it sounds like a story to you, I only learned the easiest dances: the bolero and the waltz.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not even the neighbors can know you’re a captain?” Pochita wipes windows, scrubs floors, paints walls, gets scared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what’s happening to me is awful,” Pantoja looks around distrustfully, speaks into the man’s ear. “How can someone who’s never had any contact with ‘specialists’ like them organize a Special Service, Bacacorzo?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A special assignment?” Pochita waxes doors, papers cupboards, hangs paintings. “You’re going to work in the Intelligence Service? Well, now I’m beginning to get all the mystery, Panta.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I picture the thousands of soldiers who are waiting, who are counting on me,” Captain Pantoja examines the bottles, gets emotional, dreams. “Who tick off days and think they’re already on their way, they’re going to get here, and my hair stands up on end, Bacacorzo.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t give a damn about military secrets,” Mother Leonor puts closets in order, sews curtains, dusts screens, plugs in lamps. “Secrets from your mother? Tell me, tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want to cheat them,” Captain Pantoja is getting upset. “But where am I going to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you don’t tell me, you’re going to wind up being sorry,” Pochita makes beds, puts down throw rugs, varnishes furniture, arranges glasses, plates and napkins in the cabinet. “No more little pinches wherever you like, no more nips on the ear. You choose, sonny boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To start with, Captain”—Lieutenant Bacacorzo cheers him on with a smile and a toast—”if the Special Service doesn’t come to Captain Pantoja, Captain Pantoja must go to them. It’s the simplest way, it seems to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As a spy, Panta?” Pochita rubs her hands together, looks around the room, mutters how much we’ve improved this pig sty—right, Mother Leonor? “Like in the movies? Oh, sweetheart, how exciting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take a little stroll this evening through the red-light districts of Iquitos,” Lieutenant Bacacorzo scribbles addresses on the napkin. “The Mau Mau, the 007, The One-Eyed Cat, the Little San Juan. To familiarize yourself with the atmosphere. I’d be happy to go with you, but Scavino’s instructions are final, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are you going in that outfit?” Mother Leonor answers yes, no one would recognize it, Pochita; we should get a prize. “My God, how dressed up you are. A tie, even. You’re going to roast in this heat. A top-level meeting? At night? How funny that you’re a secret agent, Panta. Yes, I know. Shh, shh—I’ll be quiet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ask in any of those places for Chino Porfirio,” Lieutenant Bacacorzo folds the napkin and puts it in his pocket. “He’s someone who can help you. He procures ‘washerwomen’ at home. You know what they are, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For this reason H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E")]), _vm._v(" did not die by drowning, by burning, by hanging or by flogging,” Brother Francisco is moaning and shouting above the sputtering of the torches and the murmuring of the prayers. “For this reason H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E")]), _vm._v(" was nailed to a piece of wood, for this reason H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E")]), _vm._v(" chose the cross. Let him who wants to listen, listen; let him who wants to understand, understand. Sisters! Brothers! Beat your breast three times for me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ahem…I mean hello,” Pantaleón Pantoja blows his nose, sits on the stool, leans on the bar. “Yeah, a beer, please. I just got to Iquitos, I’m taking a look around town. They call this place the Mau Mau? Oh, because of the arrows, the totems. I get it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here you go, ice cold,” the bartender serves the beer, dries the glass, points to the dance floor. “Almost nobody’s here ’cause it’s Monday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh, I want to find out something…umm, ah”—Pantaleón Pantoja clears his throat—“if it’s possible. Just for the information.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where can you find chicks?” The bartender makes a circle with his thumb and index finger. “Right here, but today they all went to hear Brother Francisco, the saint of the cross. They say he came all the way from Brazil on foot and that he can perform miracles. But look who’s coming in. Hey, Porfirio, over here. I want to introduce you to this gentleman. He’s interested in a little tourist information.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Blothels and dames?” Chino Porfirio winks at him, bows, shakes his hand. “Of coulse, mistel. With pleasule; I tell you what’s goin’ on in two minutes. It not goin’ to cost you much mole than a beel. Cheap, light?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Glad to meet you,” Pantaleón Pantoja motions him to sit down on the next stool. “Yeah, sure, a beer. Now don’t get the wrong idea—I don’t have any personal interest in this myself, just a technical one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Technical?” The bartender turns up his nose. “You’re no stool pigeon, are you, mister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Blothels, thele ale vely few,” Chino Porfirio holds up three fingers. “Youl health and a good life. Two decent ones and a leally foul one, fol beggals. And thele ale also the wholes that go house to house on theil own. You know, the washerwomen?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, really? Very interesting,” Pantaleón Pantoja is urging him on with smiles. “Just curious. I don’t frequent those spots. You got connections? I mean friends, contacts in those places?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Chink’s in his glory when it comes to whores,” the bartender laughs. “They call him the Fu Manchu of Bethlehem, the floating house district, the Venice of the Amazon District. You get down there yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I done evelythin’ in my life and I no leglet it, mistel,” Chino Porfirio blows off the foam and takes a swig. “I got no money but I sule got expelience. Ticket sellel fol a movie house, pilot on a balge, snake huntel fol expolt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And they kicked you outta all those jobs for bein’ a whoring old asshole, brother,” the bartender lights a cigarette for him. “Tell the man what your mama predicted about you.”")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "25%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Chinaman who’s boln pool")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "25%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dies a pimp, thief ol fool")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Chino Porfirio sings and recites with horse laughs. “God, my pletty little mothel in holy heaven. Since we only live once, we got to live it up, light? We tly a second cool dlink, mistel?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, but…ahhh, hmmm,” blushes Pantaleón Pantoja. “I have a better idea. Why don’t we go someplace else, friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Pantoja?” Madame Chuchupe breathes honey. “So very pleased to meet you, and come in, make yourself at home. We treat everyone well here, except for those crooked soldiers who want a discount. Hello, my little Chinese bandit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mistel Pantoja come flom Lima and he fliend,” Chino Porfirio kisses her on the cheek, pinches her backside. “He going to open a business hele. You know, Chuchupe, luxury selvice. This dwalfs name Fleckle, leal name Juan Chupito Civela, and he mascot of the place, mistel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Better if you said foreman, bartender and bodyguard, motherfucker,” Freckle reaches for bottles, picks up glasses, collects tabs, turns on the record player, herds women onto the dance floor. “Or is this the first time you’ve come to Casa Chuchupe? It won’t be the last, you’ll see. There aren’t many girls because they’ve gone to see Brother Francisco, that guy who put up that big cross next to Lake Morona.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was thele too and thele was lotta people, and the tlinket vendols must be laking it in,” Chino Porfirio delivers his goodbyes. “Fantastic speakel, that blothel. You not understand him vely good, but he stilling up the people.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything that you nail to wood is an offering, everything that ends up on wood rises and H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E WHO DIED ON THE CROSS")]), _vm._v(" receives it,” chants Brother Francisco monotonously. “The many-colored butterfly that gladdens the morning, the rose that perfumes the air, the bat with little eyes that glow in the dark and even the chigger encrusted under your fingernail. Sisters! Brothers! Erect crosses for me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What a long face, but you can’t be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" serious if you’re running around with this Chinaman,” Chuchupe cleans off a table with her arm, pulls up chairs, loosens up. “Let’s see, Freckle, a bottle of beer and three glasses. The first round’s on the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Know what a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chuchupe")]), _vm._v(" is?” Chino Porfirio is whistling, showing the tip of his tongue. “Most poisonous snake in Amazon. You can imagine things this woman says about people to get nickname like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Be quiet, you bum,” Chuchupe shuts him up, sets out the glasses, smiles. “To your health, Mr. Pantoja. Welcome to Iquitos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Poisonous tongue,” Chino Porfirio points to the Chinese decorations on the walls, the scarred mirror, the red screens, the dancing fringes of the mottled armchair. “Just that she good fliend and this house, though it seen its yeals, is best in Iquitos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take a look at what’s left of the goods, if nothing else,” Freckle is pointing: little half-breeds, whites, Japanese, even an albino. “It took a good eye on Chuchupe’s part to choose her women, mister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good music, makes you wanna dance,” Chino Porfirio gets up, grabs the arm of a woman, drags her to the dance floor, dances. “A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pemisito")]), _vm._v(" to shake up youl bones. C’me hele, fatty. C’me hele.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I buy you another beer, Madame Chuchupe?” Pantaleón Pantoja coaxes an uneasy smile and whispers, “I’d like to ask you for a few facts, if it’s no trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What a friendly devil that Chino is. He never has any money but how he livens up an evening,” Chuchupe folds a piece of paper, throws it at Porfirio’s head, hits the target. “I don’t know what they see in him. They’re all dying for him. Look at him going nuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Matters related to your—you know—to your business,” insists Pantaleón Pantoja.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, happy to,” Chuchupe gets serious, agrees, autopsies him with her stare. “Though I didn’t think you came to talk about business but for something else, Mr. Pantoja.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My head is killing me,” Pantita curls up, covers himself with the sheets. “My body is falling to pieces, I got the shivers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why wouldn’t it kill you, why wouldn’t you have, and what’s more, it makes me glad,” Pochita taps her heels. “You went to bed around four and you came in falling-down drunk, you idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve vomited three times,” Mother Leonor goes back and forth between kettles, washbasins and towels. “You’ve left the room stinking, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going to explain what all this means, Panta,” Pochita approaches the bed, eyes blazing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I already told you, sweetheart—it’s got to do with work,” complains Pantita from between the pillows. “You know only too well I don’t drink, how I hate keeping late hours. It’s torture for me to do those things, dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean to tell me you’re going to go on doing them?” Pochita grimaces, screws up her face. “Going to bed at dawn, getting drunk? Oh, no you’re not, Panta—I promise you you’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on, don’t fight,” Mother Leonor is carefully balancing the glass, the pitcher, the tray. “Come, child, put on these cold towels and take this Alka-Seltzer. Quick, with the little bubbles.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s my work, it’s the assignment they’ve given me,” Pantita despairs, fades, loses his voice. “I hate all this—you’ve got to believe me. But I can’t tell you anything. Don’t make me talk; it’d be very bad for my career. Have faith in me, Pocha.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve been with women,” Pochita breaks out sobbing. “Men don’t get drunk until dawn without women. I’m sure you were, Panta.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pocha, Pochita, my head is splitting, my back is hurting me,” Pantita places a cloth on his forehead, reaches under the bed, pulls out a chamber pot, spits saliva and bile. “Don’t cry. You make me feel like a criminal and I’m not, I swear to you I’m not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Close your eyes and open your yap,” Mother Leonor holds out a steaming cup, puckers her mouth. “And now this little cup of very hot coffee, my little boy.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db37ee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780374522360_ch01.vue
// module id = 72
// module chunks = 0